var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 14,
    height: 14
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.9545,
    cy: 10.9545,
    r: 6.95455,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3 4H25V18H-3V4Z",
    fill: "#6FB1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 4V5.5652L21.8696 18H25V16.4348L0.1304 4.0028H-3V4ZM25 4V5.5652L0.1304 18H-3V16.4348L21.8696 4H25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6676 4V18H13.3324V4H8.6676ZM-3 8.6676V13.3324H25V8.6676H-3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3 9.6V12.4H25V9.6H-3ZM9.6 4V18H12.4V4H9.6ZM-3 18L6.3324 13.3324H8.424L-0.914 18H-3ZM-3 4L6.3324 8.6676H4.2464L-3 5.0444V4ZM13.5788 8.6676L22.914 4H25L15.6676 8.6676H13.576H13.5788ZM25.0028 18L15.6648 13.3324H17.7508L25 16.9556V18H25.0028Z",
    fill: "#DB5F7B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.51b398b68091f6558ee85109c829cb20.svg";
export { ForwardRef as ReactComponent };